import { Product, Ticket } from '@ridango/components/lib/purchase/purchase.model';

export function isDynamicBookletProduct(product: Product | undefined): boolean {
    return product?.maxUnits != null;
}

export function ticketUnitDisplayCount(ticket: Pick<Ticket, 'units'>): number {
    return ticket.units != null && ticket.units > 0 ? ticket.units : 1;
}

export function sumTicketUnitDisplayCounts(tickets: Pick<Ticket, 'units'>[]): number {
    return tickets.reduce((sum, ticket) => sum + ticketUnitDisplayCount(ticket), 0);
}
